<template>
  <mia-form @submit="save">
    <mia-form-section title="Basisdaten">
      <template #description>
        <mia-required-field-notice />
      </template>

      <mia-form-section-grid>
        <!-- Invoice Date Sold -->
        <div ref="invoiceDateSoldWrapper">
          <mia-feature-input
            v-model="form.invoicedate_sold"
            label="VK-Rechnungsdatum"
            :errors="getErrors('item_invoicedate_sold')"
            type="date"
            required
            data-highlight="basisdaten-vk-rechnungsdatum"
            @input="clearErrors('item_invoicedate_sold')"
          />
        </div>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <div class="flex justify-between w-full">
        <mia-section-progress
          page="opos"
          section="generalData"
        />

        <mia-submit-button
          v-if="car.item_closed === 'N'"
          :disabled="$wait.any"
          :is-loading="$wait.is('updating opos general data')"
        />
        <mia-closed-hint v-else />
      </div>
    </template>
  </mia-form>
</template>

<script>
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import Form from '@/components/ui/widgets/Form.vue'
import RequiredFieldNotice from '@/components/cars/edit/forms/RequiredFieldNotice.vue'
import { handleEmptyDate } from '@/helpers/utils'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import SectionProgress from '@/components/cars/edit/SectionProgress.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import ClosedHint from '@/components/cars/ClosedHint.vue'
import { getCar } from '@/api/car'
import { updateOposGeneralData } from '@/api/cars'

export default {
  name: 'MiaCarsEditOposGeneralDataForm',

  components: {
    'mia-closed-hint': ClosedHint,
    'mia-feature-input': FeatureInput,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-required-field-notice': RequiredFieldNotice,
    'mia-section-progress': SectionProgress,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      form: {
        invoicedate_sold: ''
      }
    }
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  watch: {
    car: {
      immediate: true,
      deep: true,
      handler(car) {
        this.form.invoicedate_sold = handleEmptyDate(car.item_invoicedate_sold)
      }
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating opos general data')

      const [error] = await updateOposGeneralData(this.car.id, {
        item_invoicedate_sold: this.form.invoicedate_sold
      })

      this.$wait.end('updating opos general data')

      if (!error) {
        this.car = await getCar({
          carId: this.car.id
        })

        window.eventBus.$emit('mia-info', {
          info: ['Daten erfolgreich gespeichert.']
        })
      } else {
        this.handleBackendValidationErrors(error)

        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })
      }
    },

    focusInvoiceDateSoldField() {
      this.$refs.invoiceDateSoldWrapper.querySelector('input').focus()
    }
  }
}
</script>
